<template>
  <div>
    <el-dialog
      title="账号实名制认证"
      :visible.sync="localDialogVisible"
      width="400px"
      class="custom-dialog"
      :before-close="handleClose"
    >
      <p style="text-align: left">
        根据相关法律法规，您需要完成真实身份核验后方可使用发帖、回复、评论等功能。<br />
        你可以通过以下方式完成实名制认证。<br />
      </p>

      <p style="text-align: left">
        Hello, this community currently does not support <br />
        registration with non-Mainland China mobile <br />phone numbers.
        You can send an email to <br /><span class="highlight">tech@wch.cn</span> to consult about technical issues <br />you encounter.
        Community posts can be viewed <br /> and searched without account authentication.
      </p>

      <el-button type="primary" @click="bindTo" style="margin-top: 20px">身份信息认证</el-button>
    </el-dialog>
  </div>
</template>
  
<script>
export default {
  props: {
    bindTipFormVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
        localDialogVisible: this.bindTipFormVisible
    };
  },
  watch: {
    bindTipFormVisible(newVal) {
      this.localDialogVisible = newVal;
    }
  },
  methods: {
    bindTo() {
      // 跳转到实名制认证的页面
      this.$router.push({
        path: "/my",
        query: {
          tab: "bind",
          time: this.$dayjs().format("YYYYMMDDHHmmssSSS"),
        },
      });
    },
    handleClose(done) {
      // 将父组件的 showBindTip设置成false
      this.$emit("update:bindTipFormVisible", false);
      done();
    },
  },
};
</script>
  
<style>
.custom-dialog .el-dialog__title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  text-align: center;
}

.custom-dialog .el-dialog__body {
  font-size: 16px;
  color: #363434;
  line-height: 1.6;
  padding: 20px;
  margin-top: -20px;
}
.highlight {
  color: #007bff; /* 高亮字体颜色 */
  font-weight: bold;
  font-size: 16px !important;
}
</style>
  